<template>
  <div class="about">
    <h1>Por favor, aguarde...</h1>
  </div>
</template>

<script>

import axios from 'axios'

export default {
  name: 'Home',
  data(){
    return {
      // api: 'https://proxy.ulisite.com'
        //api: 'http://api.uli'
      token: ''
    }
  },
  mounted() {
    if(this.$route.query.token){
      this.verifyToken()  
    }
    else if (localStorage.jwt) {
      this.$router.push("/dashboard");
    }
    else{
      console.log('error')
    }
  },
  methods: {
    verifyToken,
  }
};

function verifyToken(){
  var token = this.$route.query.token

  var data = {
    token: token
  }

  var url = process.env.VUE_APP_API + '/api/application/user/login/validate'

  axios({
    method: 'post',
    url: url,
    data: data
  })
  .then(response => {
    if(response.data.status && response.data.status == 1){
      localStorage.clear();
      localStorage.jwt = response.data.token
      localStorage.application = JSON.stringify(response.data.application)
      localStorage.user = JSON.stringify(response.data.user)
      this.$router.push("/dashboard");
    }
  })
  .catch(response => {
  });
}



</script>